export const TIPO_LABELS = {
  apertura: 'Solicitud de apertura de centro',
  reconocimiento: 'Solicitud de reconocimiento',
  acreditacion: 'Solicitud de acreditación',
  evaluacion: 'Evaluación periódica del desempeño',
  cambio_director: 'Cambio de director(a) docente',
  cambio_secretario: 'Cambio de secretario(a) docente',
  cambio_nombre: 'Cambio de nombre de la institución',
  cambio_direccion: 'Cambio de dirección geográfica',
  cierre_voluntario: 'Cierre voluntario',
  cierre_minerd: 'Cierre por MINERD',
  cierre_judicial: 'Cierre judicial',
  queja_disciplina: 'Queja por sanción disciplinaria',
  queja_colegiatura: 'Queja por pago de colegiatura',
  otro: 'Otro',
};

export const TIPOS_GROUPED = [
  { group: 'Funcionamiento institucional', options: [
    { value: 'apertura', label: 'Solicitud de apertura de centro' },
    { value: 'reconocimiento', label: 'Solicitud de reconocimiento' },
    { value: 'acreditacion', label: 'Solicitud de acreditación' },
    { value: 'evaluacion', label: 'Evaluación periódica del desempeño' },
  ]},
  { group: 'Cambios en el centro', options: [
    { value: 'cambio_director', label: 'Cambio de director(a) docente' },
    { value: 'cambio_secretario', label: 'Cambio de secretario(a) docente' },
    { value: 'cambio_nombre', label: 'Cambio de nombre de la institución' },
    { value: 'cambio_direccion', label: 'Cambio de dirección geográfica' },
  ]},
  { group: 'Cierre', options: [
    { value: 'cierre_voluntario', label: 'Cierre voluntario' },
    { value: 'cierre_minerd', label: 'Cierre por MINERD' },
    { value: 'cierre_judicial', label: 'Cierre judicial' },
  ]},
  { group: 'Mediaciones y quejas', options: [
    { value: 'queja_disciplina', label: 'Queja por sanción disciplinaria' },
    { value: 'queja_colegiatura', label: 'Queja por pago de colegiatura' },
    { value: 'otro', label: 'Otro' },
  ]},
];

export const ORIENTACIONES = {
  apertura: {
    encargado: 'DACE vía Dirección Regional',
    pasos: ['Recibir solicitud escrita del centro.','Verificar ideario, horario, niveles y modalidades.','Enviar equipo técnico para evaluar condiciones.','Elaborar informe y remitir a DACE vía Regional.','DACE emite autorización si cumple requisitos.'],
    docs: ['Carta de solicitud','Formulario de evaluación DACE','Ficha de apertura SIGERD','PEC','Certificado ONAPI','Comunicación Junta de Vecinos'],
    baseLegal: 'Art. 12-18 Ordenanza 4-2000',
  },
  reconocimiento: {
    encargado: 'DACE vía Dirección Regional',
    pasos: ['Solicitud del 10 enero al 10 abril.','Evaluación en 5 dimensiones con formulario DACE.','Si no alcanza mínimos, establecer plan de mejora.','Ministro emite certificación de Reconocida.'],
    docs: ['Formulario evaluación DACE','Informe técnico distrital','Certificado ONAPI','PEC actualizado','Registros de personal docente'],
    baseLegal: 'Art. 19-24 Ordenanza 4-2000',
  },
  acreditacion: {
    encargado: 'DACE',
    pasos: ['Centro reconocido solicita evaluación.','Indicar niveles, modalidades y período.','DACE evalúa con estándares art. 8 Ord. 4-2000.','Ministro emite Resolución de acreditación.'],
    docs: ['100% personal titulado','Plan anual de actividades','Registros actualizados','Evidencia de organismos de participación'],
    baseLegal: 'Art. 25-30 Ordenanza 4-2000',
  },
  evaluacion: {
    encargado: 'Técnico distrital coordinado con DACE',
    pasos: ['Supervisión periódica como labor de asesoría.','DACE evalúa cada dos años (art. 23).','Diligenciar formulario de evaluación (100 pts).','Recomendar plan de mejora si corresponde.'],
    docs: ['Formulario evaluación DACE (100 pts)','Planta física (40 pts)','Planificación y control (20 pts)','Gestión pedagógica (20 pts)','Mobiliario/equipos (10 pts)','Participación/liderazgo (10 pts)'],
    baseLegal: 'Art. 23 Ordenanza 4-2000',
  },
  cambio_director: {
    encargado: 'DACE vía Distrito y Dirección Regional',
    pasos: ['Titular solicita por escrito vía el distrito.','Distrito verifica y tramita a DACE vía Regional.','DACE autoriza tras investigación.','Se registra en SIGERD.','Se devuelve oficio de aprobación.'],
    docs: ['Carta del titular','Oficio distrital','Oficio regional','Copia ONAPI','Hoja timbrada del candidato','CV con titulaciones','Copia cédula'],
    baseLegal: 'Art. 42 Ordenanza 4-2000',
  },
  cambio_secretario: {
    encargado: 'DACE vía Distrito y Dirección Regional',
    pasos: ['Titular solicita por escrito vía el distrito.','Distrito verifica y tramita vía Regional.','DACE autoriza y registra en SIGERD.','Se devuelve oficio de aprobación.'],
    docs: ['Carta del titular','Oficio distrital','Oficio regional','Copia ONAPI','Hoja timbrada del candidato','CV','Copia cédula'],
    baseLegal: 'Art. 43 Ordenanza 4-2000',
  },
  cambio_nombre: {
    encargado: 'DACE vía Distrito y Dirección Regional',
    pasos: ['Titular registra nuevo nombre en ONAPI.','Solicita cambio adjuntando certificaciones ONAPI.','Distrito verifica y tramita vía Regional.','DACE autoriza y emite nuevo documento.'],
    docs: ['Carta del titular','Oficio distrital','Oficio regional','Certificado ONAPI anterior y nuevo'],
    baseLegal: 'Art. 44 Ordenanza 4-2000',
  },
  cambio_direccion: {
    encargado: 'DACE vía Distrito y Dirección Regional',
    pasos: ['Solicitud con 6 meses de anticipación.','Distrito envía equipo técnico al nuevo local.','Si cumple, DACE valida evaluación.','Se autoriza cambio y actualiza SIGERD.'],
    docs: ['Carta con nueva dirección','Informe evaluación instalaciones','Oficio regional','Copia ONAPI','Comunicaciones Planeamiento Urbano y Junta de Vecinos'],
    baseLegal: 'Art. 45 Ordenanza 4-2000',
  },
  cierre_voluntario: {
    encargado: 'Técnico distrital coordinado con DACE',
    pasos: ['Titular comunica cierre 6 meses antes.','Distrito constituye comisión de seguimiento.','Se reciben archivos físicos y digitales.','Se llena inventario de cierre firmado.','DACE inactiva código en SIGERD.'],
    docs: ['Carta de solicitud (6 meses antes)','Sello del centro','Actas de calificaciones','Registros de grado','Expedientes de estudiantes','Inventario de cierre firmado'],
    baseLegal: 'Art. 50 Ordenanza 4-2000',
  },
  cierre_minerd: {
    encargado: 'DACE / Regional / Consejo Nacional de Educación',
    pasos: ['Distrito forma comisión con evidencias.','Se identifican normativas infringidas.','CNE determina cierre mediante Resolución.','DACE inactiva código en SIGERD.'],
    docs: ['Informe con evidencias','Registros sellados y firmados','Resolución del CNE'],
    baseLegal: 'Art. 51 Ordenanza 4-2000',
  },
  cierre_judicial: {
    encargado: 'DACE / Regional',
    pasos: ['Recibir orden judicial.','Coordinar con Regional y DACE.','Ejecutar cierre y documentar.','DACE inactiva código en SIGERD.'],
    docs: ['Orden judicial','Acta de cierre','Inventario firmado'],
    baseLegal: 'Art. 52 Ordenanza 4-2000',
  },
  queja_disciplina: {
    encargado: 'Técnico distrital / Instancias de mediación',
    pasos: ['Recibir queja de la familia.','Verificar que el centro tiene Reglamento de convivencia.','Mediación distrital/regional si no resuelto.','Para faltas graves: DACE atiende (art. 79 lit. e).'],
    docs: ['Escrito de la familia','Copia de la sanción del centro','Reglamento de convivencia del centro'],
    baseLegal: 'Art. 79 lit. e Ordenanza 4-2000',
  },
  queja_colegiatura: {
    encargado: 'Técnico distrital / Dirección Regional',
    pasos: ['Recibir queja sobre cobros indebidos.','Recordar: prohibido expulsar por falta de pago (art. 23 lit. k).','Favorecer solución dialogada o acuerdo de pago notarial.'],
    docs: ['Escrito del centro o familia','Estado de cuenta','Acuerdo de pago si se establece'],
    baseLegal: 'Art. 23 lit. k Ordenanza 4-2000',
  },
  otro: {
    encargado: 'Técnico encargado de instituciones privadas',
    pasos: ['Analizar el caso recibido.','Determinar la normativa aplicable.','Coordinar con la instancia correspondiente.','Dar seguimiento hasta resolución.'],
    docs: ['Documentos relacionados al caso'],
    baseLegal: 'Ordenanza 4-2000 / Manual de Procedimientos MINERD',
  },
};
